import { get, post, destroy, patch } from 'apis/httpClient'

// export const getStaffs = (params) => get('/user/staff', params)
// export const addStaff = (body) => post('/user/staff/add', body)
// export const updateStaff = (body, id) => patch('/user/staff/update/' + id, body)

export const getAllEmployee = (params) => get('/employee', params)
export const addEmployee = (body) => post('/employee/create', body);
export const updateEmployee = (id, body) => patch(`/employee/update/${id}`, body)
export const deleteEmployee = (body) => destroy('/employee/delete/', body)
